export default {
  // ACCOUNTS
  '___accounts_page-title': '',
  ___accounts_title_resources: '',

  // ACCOUNTS OVERVIEW
  'accounts-overview_action_view-previous-accounts': 'View Previous Accounts',
  '___account-overview_action_view-account': '',
  '___accounts-overview_label_available-balance': '',

  // BANNER
  'banner-blackout-text': 'You are currently in a blackout period as we are preparing to transfer your account. As a result, all online functionality has been suspended. We apologize for any inconvenience.',

  // INACTIVE ACCOUNTS
  '___inactive-accounts_page-title': '',
  'inactive-accounts_action_view-current-accounts': 'View Current Accounts',

  // ACCOUNT
  '___account_menu-item_overview': '',
  '___account_menu-item_activity': '',
  '___account_menu-item_statements': '',
  'account_menu-item_tax-forms': 'Tax Forms',
  '___account_menu-item_beneficiaries': '',
  'account_menu-item_eligibility': 'What’s Covered',
  '___account_label_account-balance': '',

  // ACCOUNT OVERVIEW
  'account-overview_title_tax-year-contributions': 'HSA Tax Year Contributions',
  '___account-overview_title_recent-activity': '',
  'account-overview_title_year-to-date-spending': 'Year-to-date Spending',
  'account-overview_title_spent-plan-fsa': 'Spent - Plan YTD',
  'account-overview_subtitle_contributions-hsa-tax-years':
    '%year1% Tax Year | %year2% Tax Year',
  'account-overview_label_your-coverage': 'Your Coverage: %coverageType%',
  'account-overview_label_your-hsa-type': 'Your HSA',
  '___account-overview_action_see-all-activity': '',
  '___account-overview_action_edit-coverage': '',
  'account-overview_action_view-hsa-info': 'View Information',
  '___account-overview_title_investments': '',
  'account-overview_label_grace-period-end-date': 'Grace Period End Date',
  'account-overview_label_claims-filing-deadline': 'Claims Filing Deadline',
  'account-overview_label_runout-period-append': 'months from date of claim',
  '___account-overview_text_no-recent-activity': '',
  '___account-overview_title_resources': '',
  '___account-overview_label_current-year': '',
  'account-overview_title_balance-amounts': 'Balance Amounts',

  // ACCOUNT ACTIVITY
  'account-activity_title_posted-transactions': 'Posted Transactions',
  'account-activity_title_scheduled-activity': 'Scheduled Activity',
  'account-activity_title_pending-transactions': 'Pending Transactions',
  '___account-activity_filter-label_date-range': '',
  'account-activity_filter-label_custom-range-start-date': 'From',
  'account-activity_filter-label_custom-range-end-date': 'To',
  'account-activity_filter-label_activity-type': 'Activity Type',
  '___account-activity_filter-label_search': '',
  'account-activity_header_summary': 'Summary',
  '___account-activity_header_note-to-self': '',
  'account-activity_header_note-to-provider': 'Note to Provider',
  '___account-activity_header_attachments': '',
  '___account-activity_header_summary': '',
  'account-activity_label_all-activity': 'All Activity',
  'account-activity_label_current-tax-year': 'Current Tax Year',
  'account-activity_label_prior-tax-year': 'Prior Tax Year',
  'account-activity_label_last-90-days': 'Last 90 Days',
  'account-activity_label_last-60-days': 'Last 60 Days',
  'account-activity_label_last-30-days': 'Last 30 Days',
  'account-activity_label_custom-date-range': 'Custom Dates',
  'account-activity_label_total-paid': 'Total Paid',
  'account-activity_label_payment-type': 'Payment Type',
  'account-activity_label_issue-date': 'Payment Issue Date',
  'account-activity_label_payee': 'Payee',
  'account-activity_label_posted-contributions-ytd': 'Posted Contributions YTD',
  'account-activity_label_expenses-ytd': 'Expenses YTD',
  '___account-activity_label_posted': '',
  '___account-activity_label_received': '',
  '___account-activity_label_tax-year': '',
  '___account-activity_label_account': '',
  '___account-activity_label_source': '',
  '___account-activity_label_claim-number': '',
  '___account-activity_label_service-type': '',
  '___account-activity_label_patient': '',
  '___account-activity_label_provider': '',
  'account-activity_label_service-date': 'Service Date',
  '___account-activity_label_service-from-date': '',
  '___account-activity_label_service-to-date': '',
  '___account-activity_label_amount-submitted': '',
  '___account-activity_label_amount-approved': '',
  '___account-activity_label_denial-adjustment-reason': '',
  'account-activity_text_documentation-required-alert':
    'Documentation required for substantiation on this debit card transaction.',
  '___account-activity_action_attach-document': '',
  '___account-activity_action_add-note': '',
  '___account-activity_action_update-transaction': '',
  '___account-activity_action_cancel-transaction': '',
  '___account-activity_action_print': '',
  'account-activity_action_export-to-xls': 'XLS',
  'account-activity_action_export-to-pdf': 'PDF',
  '___account-activity_label_pagination-page-span': '',
  '___account-activity_filter-hint_date': '',
  'account-activity_form-error_custom-range-start-date_invalid-format':
    'Invalid From Date',
  'account-activity_form-error_custom-range-start-date_before-account-start-date':
    'From Date cannot be prior to the account start date',
  'account-activity_form-error_custom-range-start-date_invalid-date-future':
    'From Date cannot be in the future',
  'account-activity_form-error_custom-range-start-date_after-end-date':
    'From Date must be prior to From Date',
  'account-activity_form-error_custom-range-end-date_invalid-format':
    'Invalid To Date',
  'account-activity_form-error_custom-range-end-date_before-start-date':
    'To Date cannot be prior to the From Date',
  'account-activity_form-error_custom-range-end-date_invalid-date-future':
    'To Date cannot be in the future',
  'account-activity_label_no-transactions': 'No transactions found',
  '___account-activity-export_text_error-title': '',
  'account-activity-export_text_error-message':
    'Your download is unavailable at this time. Please try again.',
  '___account-activity-export_try-again': '',
  '___account-activity-export_im-done': '',
  'account-activity_action_open-eop': 'Payment Details',

  // CANCEL ACTIVITY
  'cancel-scheduled-deposit_page-title': 'Cancel scheduled deposit',
  'cancel-scheduled-deposit_page-description':
    "Are you sure you want to cancel the scheduled deposit '%description%' which is scheduled on %date% in the amount of %amount%?",
  '___cancel-scheduled-deposit_action_cancel': '',
  '___cancel-scheduled-deposit_action_confirm': '',
  'cancel-scheduled-deposit_text_success-message': 'Deposit canceled',
  '___cancel-scheduled-deposit_action_done': '',
  'cancel-scheduled-deposit_text_error-message_default':
    'An error occurred while canceling the deposit. Please try again.',
  'cancel-scheduled-deposit_text_loading-message': 'Canceling deposit',
  'cancel-scheduled-deposit_text_refresh-data-error-message':
    'Your deposit has been cancelled but we were unable to refresh the data on the screen. Please refresh the page.',
  '___cancel-scheduled-deposit_confirm_title': '',
  '___cancel-scheduled-deposit_confirm_text': '',
  '___cancel-scheduled-deposit_yes': '',
  '___cancel-scheduled-deposit_no': '',

  // CANCEL PENDING INVESTMENT
  'cancel-pending-investment_page-title': 'Cancel pending investment',
  'cancel-pending-investment_page-description':
    "Are you sure you want to cancel the pending investment '%description%' in the amount of %amount%?",
  '___cancel-pending-investment_action_cancel': '',
  '___cancel-pending-investment_action_confirm': '',
  'cancel-pending-investment_text_success-message':
    'Investment transaction canceled',
  '___cancel-pending-investment_action_done': '',
  'cancel-pending-investment_text_error-message_default':
    'An error occurred while canceling the investment transaction. Please try again.',
  'cancel-pending-investment_text_loading-message':
    'Canceling investment transaction',
  'cancel-pending-investment_text_refresh-data-error-message':
    'Your investment has been cancelled but we were unable to refresh the data on the screen. Please refresh the page.',
  '___cancel-pending-investment_confirm_title': '',
  '___cancel-pending-investment_confirm_text': '',
  '___cancel-pending-investment_yes': '',
  '___cancel-pending-investment_no': '',

  // CANCEL PENDING CLAIM
  'cancel-pending-claim_page-title': 'Cancel pending claim',
  'cancel-pending-claim_page-description':
    "Are you sure you want to cancel the scheduled deposit '%description%' which is scheduled on %date% in the amount of %amount%?",
  '___cancel-pending-claim_action_cancel': '',
  '___cancel-pending-claim_action_confirm': '',
  'cancel-pending-claim_text_success-message': 'Claim canceled',
  '___cancel-pending-claim_action_done': '',
  'cancel-pending-claim_text_error-message_default':
    'An error occurred while canceling the claim. Please try again.',
  'cancel-pending-claim_text_loading-message': 'Canceling claim',
  'cancel-pending-claim_text_refresh-data-error-message':
    'Your claim has been cancelled but we were unable to refresh the data on the screen. Please refresh the page.',
  '___cancel-pending-claim_confirm_title': '',
  '___cancel-pending-claim_confirm_text': '',
  '___cancel-pending-claim_yes': '',
  '___cancel-pending-claim_no': '',

  // CANCEL PENDING REIMBURSEMENT
  'cancel-pending-reimbursement_page-title': 'Cancel pending reimbursement',
  'cancel-pending-reimbursement_page-description':
    "Are you sure you want to cancel the pending claim '%description%' in the amount of %amount%?",
  '___cancel-pending-reimbursement_action_cancel': '',
  '___cancel-pending-reimbursement_action_confirm': '',
  'cancel-pending-reimbursement_text_success-message': 'Claim canceled',
  '___cancel-pending-reimbursement_action_done': '',
  'cancel-pending-reimbursement_text_error-message_default':
    'An error occurred while canceling the claim. Please try again.',
  'cancel-pending-reimbursement_text_loading-message': 'Canceling claim',
  'cancel-pending-reimbursement_text_refresh-data-error-message':
    'Your reimbursement has been cancelled but we were unable to refresh the data on the screen. Please refresh the page.',
  '___cancel-pending-reimbursement_confirm_title': '',
  '___cancel-pending-reimbursement_confirm_text': '',
  '___cancel-pending-reimbursement_yes': '',
  '___cancel-pending-reimbursement_no': '',

  // UPDATE ACTIVITY
  '___update-scheduled-deposit_confirm_title': '',
  '___update-scheduled-deposit_confirm_text': '',
  '___update-scheduled-deposit_action_confirm-close_cancel': '',
  '___update-scheduled-deposit_action_confirm-close_confirm': '',
  'update-scheduled-deposit_error-message': 'Unable to load deposit details.',

  // ADD TRANSACTION NOTE
  '___add-claim-note_confirm_title': '',
  '___add-claim-note_confirm_text': '',
  '___add-claim-note_no': '',
  '___add-claim-note_yes': '',
  'add-claim-note_title': 'Add Note',
  'add-claim-note_label_note': 'Add a note',
  '___add-claim-note_action_cancel': '',
  '___add-claim-note_action_save': '',
  'add-claim-note_text_success-message': 'Note saved',
  '___add-claim-note_action_done': '',
  'add-claim-note_text_error-message_default':
    'An error occurred while saving your note. Please try again.',
  'add-claim-note_text_loading-message': 'Saving note',
  'add-claim-note_text_refresh-data-error-message':
    'Your note has been added but we were unable to refresh the data on the screen. Please refresh the page.',
  '___add-claim-note_error_note_required': '',
  'add-claim-note_error_note_length':
    'Note cannot be longer than %maxLength% characters.',

  // ACCOUNT BALANCE
  '___account-balance_label_available-balance': '',
  'account-balance_label_threshold': 'Threshold',
  'account-balance_label_accumulation': 'Accumulation',
  'account-balance_label_beginning-balance': 'Beginning Balance (%startDate%)',
  'account-balance_label_rollover': 'Rollover from Prior Year',
  'account-balance_label_election-amount': 'Election Amount',
  'account-balance_label_employer-funding': 'Employer Funding',
  'account-balance_label_contributions': 'Contributions',
  'account-balance_label_expenses': 'Expenses',
  'account-balance_label_pending-transactions': 'Pending Transactions',
  'account-balance_label_invested-balance': 'Invested Balance',
  '___account-balance_label_total-balance': '',
  '___account-balance_label_unprocessed-transactions': '',

  // ACCOUNT CLAIMS
  '___account-claims_page-title': '',
  'account-claims_page-description':
    'The following transactions need your immediate attention.',
  'account-claims_text_documentation-required-alert':
    'Documentation required for reimbursement.',
  '___account-claims_label_posted': '',
  '___account-claims_label_received': '',
  '___account-claims_label_tax-year': '',
  '___account-claims_label_note': '',
  '___account-claims_action_attach-document': '',
  '___account-claims_action_add-note': '',
  '___account-claims_action_print': '',
  '___account-claims_action_update-transaction': '',
  '___account-claims_action_cancel-transaction': '',
  '___account-claims_label_pagination-page-span': '',

  // ACCOUNT ELIGIBILITY
  'account-eligibility_page-title': 'Expense Eligibility',

  // ACCOUNT STATEMENTS
  '___account-statements_page-title': '',
  '___account-statements_title_related': '',
  'account-statements_title_tax-statements': 'Tax Statements',
  'account-statements_filter-label_report-period': 'Report Period',
  'account-statements_filter-label_month-ending': 'Month Ending',
  '___account-statements_filter-label_tax-year': '',
  'account-statements_filter-label_report-start-date': 'Report Start Date',
  'account-statements_filter-label_report-end-date': 'Report End Date',
  'account-statements_filter-label_report-as-of-date': 'Report As Of Date',
  '___account-statements_filter-hint_date': '',
  'account-statements_form-error_report-start-date_required':
    'Report Start Date is required',
  'account-statements_form-error_report-start-date_after-account-start-date':
    'Report Start Date cannot be prior to the account start date',
  'account-statements_form-error_report-start-date_invalid-format':
    'Invalid Report Start Date',
  'account-statements_form-error_report-end-date_after-account-end-date':
    'Report End Date must be prior to the account end date',
  'account-statements_form-error_report-start-date_invalid':
    'Report Start Date must be prior to Report End Date',
  'account-statements_form-error_report-end-date_required':
    'Report End Date is required',
  'account-statements_form-error_report-end-date_invalid-format':
    'Invalid Report End Date',
  'account-statements_form-error_report-end-date_invalid':
    'Report End Date cannot be prior to Report Start Date',
  'account-statements_form-error_report-as-of-date_required':
    'Report As Of Date is required',
  'account-statements_form-error_report-as-of-date_after-account-start-date':
    'Report As Of Date cannot be prior to the account start date',
  'account-statements_form-error_report-as-of-date_invalid-format':
    'Invalid Report As Of Date',
  'account-statements_form-error_report-as-of-date_invalid':
    'Report As Of Date cannot be prior to %minDate%',
  '___account-statements_label_pagination-page-span': '',
  'account-statements_label_beginning-balance': 'Beginning Balance',
  'account-statements_label_deposits': 'Deposits for Current Tax Year',
  'account-statements_label_investment-account-transfer':
    'Investment Account Transfer',
  'account-statements_label_interest-earned': 'Interest Earned',
  'account-statements_label_withdrawals': 'Withdrawals',
  'account-statements_label_fees': 'Fees',
  'account-statements_label_available-base-balance': 'Available Base Balance',
  'account-statements_label_investment-account-balance':
    'Investment Account Balance',
  'account-statements_action_visit-investment-site': 'Visit Investment Site',
  '___account-statements_tax-forms_error-title': '',
  '___account-statements_tax-forms_error-message': '',
  '___account-statements_tax-forms_try-again': '',
  '___account-statements_tax-forms_im-done': '',
  '___account-statements_label_pagination-page-span': '',
  'account-statements_label_no-transactions': 'No transactions found',
  'account-statements_filter-label_statement-type': 'Transaction type',
  'account-statements_label_transactions': 'Transactions in Selected Period',
  'account-statements_label_no-transactions': 'No transactions to display.',
  'statements_label-overview': 'Statement Overview',

  'statements_label-overview': 'Statement Overview',
  'statements_label-service': 'Service',
  'statements_label-service-date': 'Service date',
  'statements_label-service-dates': 'Service dates',
  'statements_label-patient': 'Patient',
  'statements_label-provider': 'Provider',
  'statements_label-claim-number': 'Claim number',
  'statements_label-denial-amount': 'Denial amount',
  'statements_label-denial-reason': 'Denial reason',

  // ACCOUNT TAX DOCUMENTS
  '___account-tax-forms_page-title': '',
  '___account-tax-forms_title_related': '',
  'account-tax-forms_title_tax-statements': 'Tax Statements',
  '___account-tax-forms_tax-forms_error-title': '',
  '___account-tax-forms_tax-forms_error-message': '',
  '___account-tax-forms_tax-forms_try-again': '',
  '___account-tax-forms_tax-forms_im-done': '',
  'account-tax-forms_headline_1099': '1099-SA',
  'account-tax-forms_headline_5498': '5498-SA',
  'account-tax-forms_form-label_statement-year': 'Tax Year',
  'account-tax-forms_body_1099-description':
    'If you made a withdrawal from your HSA during the tax year, the IRS requires you to report the withdrawals on Form 8889 when filing your tax returns. This 1099-SA will give you the information you need to complete Form 8889. Each year a new 1099 is generated for the tax year by January 31st the following year.',
  'account-tax-forms_body_5048-description':
    'Tax document Form 5498-SA includes information regarding contributions made for a specific tax year. Since contributions can be made to an HSA uptown the tax filing deadline (generally April 15th of the following year), the 5498-SA is generated the month following the deadline (May) as an informational form. You can use this document to make sure the information matches your tax filing.',
  'account-tax-forms_button_get-statement': 'Get Form',
  'account-tax-forms_title_description':
    "On this page you can download tax forms with your information entered. Choose the tax year you'd like to see.",
  'account-tax-forms_page-no-tax-forms':
    'There are no tax forms available for this account.',

  // EOP
  '___account-activity-eop_confirm-close_title': '',
  '___account-activity-eop_confirm-close_text': '',
  '___account-activity-eop_no': '',
  '___account-activity-eop_yes': '',
  '___account-activity-eop_im-done': '',
  'account-activity-eop_title': 'Explanation of Payment (EOP)',
  'account-activity-eop_title_payment-summary': 'Payment Summary',
  'account-activity-eop_title_individual-claims': 'Individual Claims',
  'account-activity-eop_total-paid': 'Total Paid',
  'account-activity-eop_payment-type': 'Payment Type',
  'account-activity-eop_payment-issue-date': 'Payment Issue Date',
  'account-activity-eop_payee': 'Payee',
  'account-activity-eop_table-header_account': 'Account',
  'account-activity-eop_table-header_source': 'Source',
  'account-activity-eop_table-header_claim-number': 'Claim #',
  'account-activity-eop_table-header_service-type': 'Service Type',
  'account-activity-eop_table-header_patient': 'Patient',
  'account-activity-eop_table-header_service-from': 'Start date',
  'account-activity-eop_table-header_service-to': 'End date',
  'account-activity-eop_table-header_submitted': 'Submitted',
  'account-activity-eop_table-header_approved': 'Approved',
  'account-activity-eop_table-header_reason': 'Reason',
  'account-activity-eop_text_na': 'N/A',
  'account-activity-eop_action_important-information': 'Important Information',

  // MANAGE ACCOUNT
  '___account-manage_page-title': '',

  // ACCOUNT CONTRIBUTIONS BAR
  '___account-contributions-bar_label_minimum': '',
  '___account-contributions-bar_label_individual-max': '',
  '___account-contributions-bar_label_family-max': '',
  '___account-contributions-bar_label_max-with-rollover': '',
  'account-contributions-bar_label_spending-goal': 'Spending Goal',
  'account_contributions-bar_label_ytd-contribution': 'YTD Contribution',
  'account_contributions-bar_label_ytd-spending': 'YTD Spending',
  'account-contributions-bar_label_family-max-plus-catch-up':
    'Family Max plus Catchup Contribution',

  // INVESTMENT
  'account-investment_action_visit-investment-site': 'Visit Investment Site',
  'account-investment_action_change-election': 'Change Election',
  'account-investment_action_open-investment-account':
    'Open an investment account',
  'account-investment_action_transfer-to-investment-account':
    'Transfer funds to investment',
  'account-investment_label_investment-balance': 'Investment Balance',
  'account-investment_label_investment-future-contribution-percentage':
    'Your current contribution amount is %percentage%%',
  'account-investment_label_balance-as-of-date': 'Balance as of %date%',
  '___account-investment_label_account-status': '',
  'account-investment_text_status-over-threshold-hsa':
    'Now that your HSA account balance has reached $%investmentThreshold%, you are eligible to open a Basic Investment Account through an agreement with the Charles Schwab Trust Company (Schwab).',
  'account-investment_text_status-over-threshold-veba':
    'Now that your VEBA account balance has reached $%investmentThreshold%, you are eligible to open a Basic Investment Account through an agreement with the MG Trust Company.',
  'account-investment_text_status-under-threshold':
    'You will need a higher balance before opening an investment account.',

  // ACCOUNTS BUTTON GROUP
  '___accounts-button-group_action_get-reimbursed': '',
  '___accounts-button-group_action_make-deposit': '',
  '___accounts-button-group_action_pay-bill': '',
  'accounts-button-group_action_invest': 'Transfer Funds to Investment',
  '___accounts-button-group_action_manage-card': '',

  // STATEMENTS
  statements_label_accumulation: 'Accumulation',
  statements_label_threshold: 'Threshold',
  'statements_label_start-date': 'Account Start Date',
  'statements_label_end-date': 'Account End Date',
  'statements_label_current-plan-type': 'Current Plan Type',
  'statements_label_termination-date': 'Plan Termination Date',
  'statements_label_grace-period': 'Grace Period End Date',
  'statements_label_filing-deadline': 'Claims Filing Deadline',
  'statements_label_months-from-claim': 'months from date of claim.',
  'statements_button_get-statement': 'Get Statement',
  'statements_label_ending-balance': 'Ending Balance',

  'statements_label_beginning-balance': 'Beginning Balance (Effective: %effectiveDate%)',
  statements_label_rollover: 'Rollover from Prior Year',
  'statements_label_contributions-current-tax-year':
    'Current Tax Year Contributions',
  'statements_label_contributions-prior-tax-year':
    'Prior Tax Year Contributions',
  'statements_label_election-amount': 'Election Amount',
  'statements_label_employer-function': 'Employer Funding',
  statements_label_contributions: 'Contributions',
  'statements_label_other-transfers': 'Other Transfers',
  'statements_label_investment-transfers': 'Investment Account Transfers',
  'statements_label_interest-earned': 'Interest Earned',
  statements_label_withdrawls: 'Withdrawals',
  statements_label_fees: 'Fees',
  'statements_label_available-balance': 'Available Balance',
  'statements_label_available-base-balance': 'Available Base Balance',
  'statements_label_n/a': 'N/A',
  'statements_label_monthly-statement': 'Monthly Statement',
  'statements_label_tax-year': 'Tax Year',
  'statements_label_date-range': 'Specified Date Range',

  // ATTACHMENTS
  '___view-attachment_confirm_title': '',
  '___view-attachment_confirm_text': '',
  '___view-attachment_no': '',
  '___view-attachment_yes': '',
  '___view-attachment_text_loading-message': '',
  '___view-attachment_text_error-message': '',
  '___view-attachment_action_done': '',
  'view-attachment_text_uploaded-at': 'Uploaded:',
  '___view-attachment_text_download': '',
  '___view-attachment_text_im-done': '',
  'view-attachment_label_amount': 'Amount',
  'view-attachment_label_category': 'Category',
  'view-attachment_label_upload-date': 'Upload Date',
  'view-attachment_label_from-date': 'From Date',
  'view-attachment_label_to-date': 'To Date',
  'view-attachment_label_patient-name': 'Patient Name',
  'view-attachment_label_provider-name': 'Provider Name',
  'view-attachment_label_note': 'Note',

  transactions_require_substatiation:
    'You have card transactions that require substantiation.',
  'transactions_action_go-to-transactions': 'View Transactions',

  //TASK LIST
  'task_list-headline': 'My Tasks',
  'recent_activity-headline': 'Recent Activity',

  // QUESTIONS
  'segmentation-questions_headline_signed-in': "You're signed in,",
  'segmentation-questions_subhead_intro':
    'Before you continue to your account, please answer these quick questions about your HSA experience.',
  'segmentation-questions_question_1': '1. Is this your first HSA?',
  'segmentation-questions_question_1_answer_1': 'Yes',
  'segmentation-questions_question_1_answer_2': 'No',
  'segmentation-questions_question_1_answer_3': "Don't Know",
  'segmentation-questions_question_2':
    '2. Which option best describes how you plan to use your HSA?',
  'segmentation-questions_question_2_answer_1': 'Spender',
  'segmentation-questions_question_2_answer_2': 'Saver',
  'segmentation-questions_question_3':
    '3. How comfortable would you be explaining how an HSA works to a friend?',
  'segmentation-questions_question_3_label_1': 'Not Comfortable',
  'segmentation-questions_question_3_label_2': 'Somewhat Comfortable',
  'segmentation-questions_question_3_label_3': 'Super Comfortable',
  'segmentation-questions_text_success-message': 'Successfully submitted!',
  '___segmentation-questions_text_loading-message': '',
  'segmentation-questions_text_refresh-data-error-message':
    'Your answers have been submitted but we were unable to refresh the data on the screen. Please refresh the page.',

  'auth-token_text_loading-message': 'Sending token...',
  'global_error-generic':
    'Unable to process the information at this time.  Please try again.',
  'auth-token_error':
    'Unable to process the information at this time.  Please try again.',
  'auth-token_yes': 'Submit',
  'auth-token_no': 'Cancel',

  // SEGMENTATION QUESTIONS
  'segmentation-question-1': 'Is this your first HSA?',
  'segmentation-question-2':
    'Which option best describes how you plan to use your HSA?',
  'segmentation-question-3':
    'How comfortable would you be explaining how an HSA works to a friend?',

  // SUBSTANTIATION ALERT
  'substantiation-alert_description': 'You have unubstantiated claims',
  'substantiation-alert_action_view': 'View Unsubstantiated Claims',
  'unsubstantiated-claims_title': 'Unsubstantiated Claims',
  'unsubstantiated-claims_description': '',
  'unsubstantiated-claims_text_no-data': 'You have no unsubstantiated claims.',
  '___unsubstantiated-claims_action_attach-document': '',
  '___unsubstantiated-claims_label_pagination-page-span': '',

  // INTEREST RATES
  'account-hsainfo_page-header-title': 'HSA Plan Information',
  'account-hsainfo_page-header-subtitle': 'Interest Rates and Terms & Conditions',
  'account-hsainfo_page-title': 'Your HSA: %hsaType%',
  'account-hsainfo_page-description': 'You will earn monthly interest based on the the average daily base balance in your account for that month. Base balalnce does not include any invested HSA funds.',
  'account-hsainfo_label-interest-effective-date': 'Interest rates effective as of June 1, 2020',
  'account-hsainfo_action_back': 'Back to my account',

  // Migration Banners
  'hsa-transition-banner-action-text': 'Learn More',
  'hsa-blackout-banner-action-text': 'Learn More',
  'hqy-sso-link-markdown': ' [access your account](action="hqySSO")',
  'hqy-no-sso-link': ' access your account',
  'hsa-transition-complete-banner-text': 'It’s official! Your HSA balance is now available on the HealthEquity portal. ',
  'hsa-transition-complete-banner-carefirst-text': `It’s official! Your balance is now available on the HealthEquity portal. From this point forward, please submit all claims you want processed against your account(s) on the HealthEquity portal.`,
  'hsa-transition-complete-banner-action-text': 'Visit Portal',
  'hia-transition-complete-banner-text': 'It’s official! Your HIA balance is now available on the HealthEquity portal. ',
  'hia-migrated-notice-banner-text': 'Your migrated HIA balance information is now available on the HealthEquity portal.',
  'fsa-transition-banner-text': 'REMINDER: as of %migrationWaveDate%, your %yearOfMigrationWaveDate% FSA is now on the HealthEquity portal.%fsaTransitionClaimText%%fsaTransitionRolloverText%',
  'fsa-transition-banner-action-text': 'Visit Portal',
  'fsa-transition-banner-claim-text': `

Submit claims with dates of service between %fsaPriorPyStartDate% and %fsaPriorPyEndDate% to Further to spend down your prior year account balance.

Submit claims with dates of service beginning %migrationWaveDate% on the HealthEquity portal.`,
  'fsa-transition-banner-rollover-text': `

NOTICE: If funds remain in your account at the end of the runout period, allowable funds will transfer to the HealthEquity portal approximately 45 days after the end of Runout.`,
  'hra-transition-banner-text': 'REMINDER: as of %migrationWaveDate%, your %yearOfMigrationWaveDate% HRA is now on the HealthEquity portal.%hraTransitionClaimText%%hraTransitionRolloverText%',
  'hra-transition-banner-action-text': 'Visit Portal',
  'hra-transition-banner-claim-text': `

Submit claims with dates of service between %hraPriorPyStartDate% and %hraPriorPyEndDate% to Further to spend down your prior year account balance.

Submit claims with dates of service beginning %migrationWaveDate% on the HealthEquity portal.`,
  'hra-transition-banner-rollover-text': `

NOTICE: If funds remain in your account at the end of the runout period, allowable funds will transfer to the HealthEquity portal approximately 45 days after the end of Runout.`,
  'ra-midyear-transition-banner-text': 'Your FSA/HRA account will be transitioning mid-year to our HealthEquity portal on %migrationWaveDate%. As a result, there will be a blackout period beginning %blackoutStartDate% to allow us to prepare for the transition of your account.',
  'ra-midyear-transition-banner-action-text': 'Learn More',
  'ra-midyear-blackout-banner-text': 'You are currently in a blackout period as we prepare to transition your FSA/HRA to the HealthEquity portal on %migrationWaveDate%. You will still be able to incur eligible expenses during the blackout period and submit them for reimbursement once the transition is complete. We apologize for any inconvenience.',
  'ra-midyear-blackout-banner-action-text': 'Learn More',
  'ra-midyear-transition-complete-banner-text': 'It’s official! Your FSA/HRA account balance has now been transitioned and is available on the HealthEquity portal.',
  'ra-midyear-transition-complete-banner-action-text': 'Visit Portal',

  'city-of-mpls-banner-action-text': 'Visit Portal',
  'city-of-mpls-banner-text': 'All HRA and 2025 FSA Medical and Dependent Care balances will be available on the HealthEquity EZ Receipts portal as of January 15, 2026. From this point forward, please submit all claims you want processed against your account(s) on the HealthEquity portal and use your purple HealthEquity VISA card.',
  'city-of-mpls-banner-url': 'https://participant.wageworks.com/MemberLogin',
  'horizon-notice-of-transition-banner-text': 'Your account will be transitioning to a new spending account administrator as of %migrationWaveDate%. As a result, there will be a blackout period beginning 6/8/2026 as we work to transition your account. During the blackout period, all online functionalities will be suspended. We apologize for any inconvenience.'
};
